import React from 'react';
import { Box, Typography, Stack, Tooltip } from '@mui/material';
import { currency } from './format';

// Lightweight horizontal bar chart built with plain MUI boxes (no chart lib).
// data: [{ label, total, count }]
export default function SimpleBarChart({ data = [], valueKey = 'total', formatValue = currency, color = '#2563eb', emptyText = 'No data' }) {
  if (!data.length) {
    return <Typography variant="body2" color="text.secondary">{emptyText}</Typography>;
  }
  const max = Math.max(...data.map((d) => Number(d[valueKey]) || 0), 1);

  return (
    <Stack spacing={1}>
      {data.map((d) => {
        const val = Number(d[valueKey]) || 0;
        const pct = Math.max(2, (val / max) * 100);
        return (
          <Box key={d.label}>
            <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.25 }}>
              <Typography variant="caption" noWrap sx={{ maxWidth: '60%', fontWeight: 600 }} title={d.label}>
                {d.label}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {formatValue(val)}{d.count != null ? ` · ${d.count}` : ''}
              </Typography>
            </Stack>
            <Tooltip title={`${d.label}: ${formatValue(val)}`} placement="top" arrow>
              <Box sx={{ height: 8, borderRadius: 1, bgcolor: '#eef2f7', overflow: 'hidden' }}>
                <Box sx={{ height: '100%', width: `${pct}%`, bgcolor: color, borderRadius: 1 }} />
              </Box>
            </Tooltip>
          </Box>
        );
      })}
    </Stack>
  );
}
